// extracted by mini-css-extract-plugin
export default {"invertSelection":"StyleguidePage_invertSelection__1YG0-"};